// Maps a player's untradable state (from the worker's isUntradable, surfaced via the "untradable"
// attr as p.untradable / p.untradableMsg) to a user-facing message for the mobile UI. Returns null
// when the player can be traded.
//
// The worker's message for the recently-signed/acquired case is a dynamic "…for N more days"
// string; we show the clearer, fixed wording for that case (in this game a player only becomes
// temporarily untradable by signing a contract — traded players are not locked) and fall back to
// the worker's message for the other reasons (expired contract, challenge-locked, etc.).

export const untradableMessage = (p: {
	untradable?: boolean;
	untradableMsg?: string;
}): string | null => {
	if (!p || !p.untradable) {
		return null;
	}
	if (p.untradableMsg?.startsWith("Cannot trade recently-acquired")) {
		return "A player cannot be traded within 2 weeks of signing a contract";
	}
	return p.untradableMsg ?? "This player can't be traded right now.";
};
